import { Component, NgModule , OnDestroy, OnInit,
  EventEmitter, Input, Output, ViewContainerRef, OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map, Subscription} from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';


import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';
import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService,GroupSettingsModel  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

import {SystemFile} from './../../../shared/models/file.model';
import { SystemLog } from './../../../shared/models/sysLog.model';
import { Permission } from './../../../shared/models/permission.model';
import { Brand } from './../../../shared/models/brand.model';
import { BrandType } from './../../../shared/models/brandType.model';

@Component({
  selector: 'app-system-file-view',
  templateUrl: './system-file-view.component.html',
  styleUrls: ['./system-file-view.component.css']
})
export class SystemFileViewComponent implements OnInit {
  nav: any;
  file_id: number;
  file_data: any;
  model: typeof SystemFile;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService
  ) {

    this.nav = document.querySelector('nav.navbar');
    this.file_id = +this.route.snapshot.paramMap.get('file_id');
   }

  ngOnInit() {
    this.model = SystemFile;
    // this.getSystemFile(this.file_id);
  }

  getSystemFile(file_id){
      this._demoService.getSystemFile(file_id).subscribe(
         data => { this.file_data = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );

  }

}
